<template>
  <div class="top">
    <div class="twoBlockIngos">
      <clientinfo 
        :firstname="d.contragent.firstname" 
        :lastname="d.contragent.lastname" 
        :phone="d.contragent.phone" 
        :avatar="d.contragent.avatar" 
      />
    </div>

    <div class="info-order">
      <div class="info-row">
        <span class="info-label">Номер заказа:</span>
        <span class="info-value">{{ d.ordernumber }}</span>
      </div>
      
      <div class="info-row">
        <span class="info-label">Канал:</span>
        <span class="info-value">{{ bookPay[d.channel] }}</span>
      </div>
    </div>

    <h2 class="section-title">Товары</h2>

    <div class="products-list">
      <div 
        class="product-item" 
        v-for="one of d.items" 
        :key="one._id" 
        :class="{ selected: proverKas(one._id) }"
      >
        <img 
          :src="`https://api.ultimatum.store/image/${one.productid.images[0]}?quality=100&width=160&format=${getImageFormat(one.productid.images[0])}`" 
          @click="addRetun(one)"
          class="product-image"
        >
        <div class="product-info" @click="addRetun(one)">
          <p class="product-name">{{ one.name }}</p>
          <div class="product-details">
            <span class="detail-label">Кол-во:</span>
            <span class="detail-value">{{ one.quantity }}</span>
          </div>
          <div class="product-details">
            <span class="detail-label">Стоимость:</span>
            <span class="detail-value">{{ one.price.toLocaleString('ru-RU') }} ₽</span>
          </div>
          <div class="product-details">
            <span class="detail-label">Общая стоимость:</span>
            <span class="detail-value total">{{ (one.price * one.quantity).toLocaleString('ru-RU') }} ₽</span>
          </div>
        </div>

        <transition name="slimeright">
          <div class="return-menu" v-if="proverKas(one._id)">
            <div class="quantity-group">
              <span class="quantity-label">Кол-во:</span>
              <select 
                v-model="returnProduct.items.find(x => x.position == one._id).quantity" 
                @change="kVozvraty()"
                class="quantity-select"
              >
                <option v-for="index in one.quantity" :value="index">{{ index }}</option>
              </select>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <transition name="slimeright">
      <button 
        class="big_button big_button_black fixeds" 
        v-if="returnProduct.items.length > 0" 
        @click="createReturnW()"
      >
        Далее
      </button>
    </transition>
  </div>
</template>

<script setup>
import clientinfo from '@/components/client/clientitem.vue'
import { reactive, ref } from 'vue'
import { bookPay } from '@/utils/book'
import { newObject, getImageFormat } from '@/controlles/general'
import { useRouter } from 'vue-router'
import axios from '@/utils/axios'
import { role,user} from '@/controlles/auth'
import { oknoUser } from '@/controlles/client'


const r = useRouter()
const emit = defineEmits(['close'])
const { d } = defineProps(['d'])

const returnProduct = ref({ 
  order: d._id, 
  items: [], 
  ordernumber: `${d.ordernumber}R`, 
  channel: `${d.channel}`,
  comment:`Cоздан в АРМ ${user.value.firstname} ${user.value.lastname}`
})

const proverKas = (id) => {
  return !!returnProduct.value.items.find(x => x.position == id)
}

const addRetun = (one) => {
  const existingIndex = returnProduct.value.items.findIndex(x => x.position == one._id)
  
  if (existingIndex !== -1) {
    returnProduct.value.items.splice(existingIndex, 1)
    return
  }
  
  returnProduct.value.items.push({
    guid: one.guid,
    name: one.name,
    position: one._id,
    productid: one.productid._id,
    specification: one.specification,
    images: [],
    price: one.price,
    status: 'new',
    quality: 'new',
    quantity: 1,
    comments: '',
    payment: one.payment,
    cashback: one.cashback
  })
}

const kVozvraty = () => {
  const ayP = []
  let bonus = 0
  
  for (const one of returnProduct.value.items) {
    bonus += one.cashback.remove_bonus
    for (const p of one.payment) {
      const existing = ayP.find(x => x.entity == p.entity && x.service == p.service)
      if (existing) {
        existing.price = Number(existing.price) + Number(p.price * one.quantity)
      } else {
        const zp = newObject(p)
        zp.price = Number(zp.price) * one.quantity
        ayP.push(zp)
      }
    }
  }
  
  if (bonus > 0) {
    ayP.push({
      service: 'bonus',
      price: bonus,
      entity: 'none'
    })
  }
  
  return ayP
}

const createReturnW = async () => {
  try {
    const gr = await axios.post('https://api.ultimatum.store/arm/order/createreturn', returnProduct.value)
    emit('close')
    r.push(`/warehouse/returnorder?id=${gr.data.id}`)
    if(['junior-manager'].includes(role.value)){
    
      oknoUser(false)

    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<style scoped>
.top {
  margin-top: 20px;
  padding-bottom: 80px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  margin: 20px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.products-list {
  display: grid;
  gap: 12px;
}

.product-item {
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: var(--border-radius-md);
  padding: 12px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  transition: all var(--transition-fast);
  cursor: pointer;
  position: relative;
}

.product-item.selected {
  background: var(--bg-secondary);
  border-color: var(--accent-black);
}

.product-item:hover {
  background: var(--tile-hover-bg);
  border-color: var(--tile-hover-border);
}

.product-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 1px solid var(--tile-icon-bg);
  border-radius: var(--border-radius-sm);
  padding: 4px;
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
}

.product-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.detail-label {
  color: var(--text-tertiary);
  font-weight: 300;
  font-size: 14px;
}

.detail-value {
  color: var(--text-primary);
  font-weight: 400;
  font-size: 14px;
}

.detail-value.total {
  color: var(--accent-black);
}

.return-menu {
  grid-column: 1 / -1;
  padding: 12px;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-light);
  margin-top: 4px;
}

.quantity-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quantity-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  min-width: 60px;
}

.quantity-select {
  padding: 8px 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-medium);
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
  min-width: 80px;
}

.quantity-select:focus {
  outline: none;
  border-color: var(--accent-black);
}

.fixeds {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 400px;
  z-index: 100;
}

.big_button_black {
  background: var(--accent-black);
  color: var(--text-inverse);
  border: 1px solid var(--accent-black);
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.big_button_black:hover {
  background: var(--btn-accent-hover);
  border-color: var(--btn-accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px var(--shadow-color);
}

.info-order {
  width: 100%;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: var(--border-radius-md);
  padding: 14px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  padding: 4px 0;
  border-bottom: 1px solid var(--border-light);
}

.info-row:last-of-type {
  border-bottom: none;
}

.info-label {
  color: var(--text-tertiary);
  font-weight: 300;
  font-size: 14px;
}

.info-value {
  color: var(--text-primary);
  font-weight: 500;
  text-align: right;
  font-size: 14px;
}

html.dark .product-item.selected {
  background: var(--bg-tertiary);
  border-color: var(--accent-black);
}

html.dark .return-menu {
  background: var(--bg-tertiary);
}
</style>